import { RegistrationErrorCodes, VerificationErrorCodes } from '@bimdata/definitions/errors';
import store from '@/state/store';
import authenticationSlice from '@/state/authentication.slice';
import { logout } from '.';
import { loginByEmailConfirmation } from '@/api/auth';
import { ApiError } from '@bimdata/client';
import { initSession } from '@/loaders/profile';
import { handleError, reportError } from '../common';
import t from '@/utils/translate';

export default async (code: string) => {
  try {
    await loginByEmailConfirmation(code, logout);
    store.dispatch(authenticationSlice.actions.finishLogin());
    await initSession();
  } catch (error) {
    if (error.code === 401) {
      await logout();
      return;
    }

    if (error instanceof ApiError && (error.code === 403 || error.code === 400)) {
      switch (error.exceptionCode) {
        case VerificationErrorCodes.VERIFICATION_EXPIRED:
          error.message = t('authentication.message.staleEmailLink');
          break;
        case VerificationErrorCodes.INVALID_VERIFICATION_CODE:
          error.message = t('authentication.message.invalidEmailLink');
          break;
        case RegistrationErrorCodes.EMAIL_ALREADY_EXISTS:
          error.message = t('authentication.message.emailBusy');
          break;
      }
      reportError(error);
    } else {
      error = handleError(error);
    }
    throw error;
  }
};